import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getAccountCreationConfirmationError() {
      return getState().error;
    },
    isAccountCreationConfirmationRequestFailure() {
      return getState().request.isFailure;
    },
    isAccountCreationConfirmationRequestPending() {
      return getState().request.isPending;
    },
    isAccountCreationConfirmationRequestSuccess() {
      return getState().request.isSuccessful;
    },
  };
}

export { createSelector };
